'use client';

import { useEffect, useState } from 'react';

const measureScrollbarWidth = () => {
  const outerElement = document.createElement('div');
  outerElement.style.visibility = 'hidden';
  outerElement.style.width = '100px';
  document.body.appendChild(outerElement);

  const widthNoScroll = outerElement.offsetWidth;
  outerElement.style.overflow = 'scroll';

  const innerElement = document.createElement('div');
  innerElement.style.width = '100%';
  outerElement.appendChild(innerElement);

  const widthWithScroll = innerElement.offsetWidth;
  outerElement.parentNode?.removeChild(outerElement);

  return widthNoScroll - widthWithScroll;
};

export const useScrollbarWidth = () => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  useEffect(() => {
    setScrollbarWidth(measureScrollbarWidth());
  }, []);

  return scrollbarWidth;
};
